/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Row_HumidityInputs */

const en_ui_weather_row_humidity = /** @type {(inputs: Ui_Weather_Row_HumidityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Humidity`)
};

const de_ui_weather_row_humidity = /** @type {(inputs: Ui_Weather_Row_HumidityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feuchte`)
};

/**
* | output |
* | --- |
* | "Humidity" |
*
* @param {Ui_Weather_Row_HumidityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_row_humidity = /** @type {((inputs?: Ui_Weather_Row_HumidityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Row_HumidityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_row_humidity(inputs)
	return de_ui_weather_row_humidity(inputs)
});